export enum TestIds {
  AggregateField = 'aggregateField',
  AggregateFunction = 'aggregateFunction',
  Category = 'category',
  ChartType = 'chartType',
  Datasource = 'dataSource',
  DatePrecision = 'datePrecision',
  Filtering = 'filtering',
  SubCategory = 'subCategory',
}
